import React, { useRef } from 'react';
import logoTop from '../../../../assets/images/clirnet.png';
import './css/shareHeader.scss';
import Navbar from 'react-bootstrap/Navbar';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { isIosApp } from '../../../../common/common';

const ShareHeader = () => {

  return (
    <Navbar fixed="top" className="shareHeader flex-column">
      {isIosApp() &&
        <div className='iosSpecial-safe-area-top w-100'></div>
      }
      <Navbar.Brand href="javascript:void(0)">
        <img src={logoTop} alt="logo" />
      </Navbar.Brand>
    </Navbar>
  );
};

export default ShareHeader;
